export const chatAttachmentTypes = {
  any: 'any',
  image: 'image',
};
